import * as Sentry from '@sentry/react';
import { scrubBreadcrumb, scrubUrlsIntegration } from 'sentry-privacy';

import { GIT_COMMIT_SHA, SENTRY_DSN } from '@/config/runtime-env';
import { domainMeta } from '@/utils/domain-meta';

/**
 * Browser error reporting for the Source dashboard.
 *
 * Dormant unless VITE_SENTRY_DSN is baked into the build. That gate is the whole
 * switch: a local `npm run dev` and a Vitest run both leave it unset and
 * therefore start no client at all.
 *
 * One bundle serves every tenant, so the DSN is a build-time constant while the
 * environment and tenant are read from the hostname at load.
 */
export function initSentry(): void {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: domainMeta.environment,
    // Ties an event to the build that produced it, and to the source maps
    // uploaded under the same name.
    release: GIT_COMMIT_SHA || undefined,
    // No console logs, and `scrubBreadcrumb` drops console breadcrumbs: what
    // the app logs includes `ApiError.body`, which is what a candidate typed.
    integrations: [
      // Page and request URLs carry credentials and search terms.
      scrubUrlsIntegration(),
    ],
    beforeBreadcrumb: scrubBreadcrumb,
    // No email, no name, no IP address. A recruiter's uuid is what "users
    // affected" counts, and it is attached separately.
    sendDefaultPii: false,
  });

  Sentry.setTag('tenant', domainMeta.tenant);
}
